<template>
  <div>
    <div v-if="deviceList.length > 0">
      <el-row style="margin: 10px 0 15px 0;font-size: 0.9rem">
        <ul style="clear: both">
          <li>
            <el-select
              v-model="currentSelectDoorId"
              @change="change"
              placeholder="请选择"
              size="small"
              style="width: 95%;">
              <el-option style="float: none;text-align: center"
                         v-for="item in deviceList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.apiId">
              </el-option>
            </el-select>
          </li>
        </ul>
      </el-row>
      <el-row style="margin: 0 0 0 25px;font-size: 0.9rem">
        <ul>
          <li>
            <img src="../../../assets/images/comprehensive/门禁记录.png" style="margin-bottom: 2px;">
            <span class="ml-1 mr-1" style="font-weight: bold">门禁记录</span>
          </li>
          <li style="color: rgba(41, 159, 251, 1);font-weight: bold">
              <span v-if="doorLogs.total > 0">
            {{ doorLogs.total ? '共' + doorLogs.total + '条' : '暂无记录' }}
          </span>
            <span v-else-if="doorLogs.total <= 0">
            暂无记录
          </span>
          </li>
        </ul>
      </el-row>
      <div class="h-100 overflow">
        <!--    门禁系统-->
        <el-row :key="item.id" style="margin-left: 35px;margin-top: 10px;font-size: 0.9rem"
                v-for="item in doorLogs.records">
          <div class="p-3" style="width: 92%;border: 1px solid rgba(41, 155, 255, .2);border-radius: 5px;">
            <el-row>编号：{{ item.recordId }}</el-row>
            <el-row style="margin-top: 5px;">凭证号：{{ item.certificateId }}</el-row>
            <el-row style="margin-top: 5px;">卡类名称：{{ item.doorCardName }}</el-row>
            <el-row style="margin-top: 5px;">人员名称：{{ item.creditPersonName }}</el-row>
            <el-row style="margin-top: 5px;">设备名称：{{ item.deviceName }}</el-row>
            <el-row style="margin-top: 5px;">开门时间：{{ item.openDate }}</el-row>
          </div>
        </el-row>
        <el-pagination
          :current-page="doorLogs.current"
          :hide-on-single-page="true" :page-size="doorLogs.size"
          :pager-count="5"
          :small="true"
          :total="doorLogs.total"
          @current-change="pageChange"
          class="mb-4 mt-3 text-center"
          layout="prev, pager, next"
          style="padding-left: 35px;width: 92%;"
          v-if="doorLogs.total > 0">
        </el-pagination>
      </div>
    </div>
    <no-data style="margin-top: 20%" v-else></no-data>
  </div>
</template>

<script>
import NoData from "@/components/NoData";
import {getEntranceGuardList} from "@/network/entranceguard";

export default {
  name: "ZKDoor",
  components: {NoData},
  props: ['deviceList'],
  data() {
    return {
      doorLogs: [],
      // 当前选中门的id
      currentSelectDoorId: "",
      page: {
        data: {
          max: 3,
          index: 1
        },
      }
    }
  },
  watch: {
    currentSelectDoorId() {
      this.getData(this.page.data.index, this.page.data.max, this.currentSelectDoorId);
    },
    deviceList() {
      this.currentSelectDoorId = this.deviceList.length > 0 ? this.deviceList[0].apiId : ''
      this.getData(this.page.data.index, this.page.data.max, this.currentSelectDoorId);
    }
  },
  mounted() {
    this.getData(this.page.data.index, this.page.data.max, this.currentSelectDoorId)
  },
  methods: {
    getData(index, max, currentSelectDoorId) {
      getEntranceGuardList(index, max, currentSelectDoorId).then(res => {
        if (res.code === 0) {
          this.doorLogs = res.data
        }
      })
    },
    // 翻页
    pageChange(page) {
      this.getData(page, this.page.data.max, this.currentSelectDoorId);
    },
    change() {
      this.getData(this.page.data.index, this.page.data.max, this.currentSelectDoorId);
    }
  }
}
</script>

<style scoped>
ul li, ul {
  padding: 0;
  float: left;
  list-style: none;
}
</style>
